export default __webpack_public_path__ + "static/media/clouds.b9e00106.png";